
import Vue from 'vue'
export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  data() {
    return {
      selectedOption: ''
    }
  },
  computed: {
    radioGroupItems: function(): { label: string, value: any }[] {
      try {
        return JSON.parse(this.input.items);
      } catch (error) {
        return [];
      }
    }
  },
  watch: {
    selectedOption: function(value: any) {
      const { prefix: prefix1, key: key1 } = this.parent._getPrefixAndKey(this.input.variable);
      const initialData = this.getVariable(prefix1);
      const { prefix, key } = this.parent._getPrefixAndKey(prefix1);
      this.$set(this.getVariable(prefix), key, { ...initialData, [key1]: value });
    } 
  },
  mounted() {
    this.$watch(
      () => this.parent._getVariable(this.input.variable), 
      async (selectedValue) => {
        this.selectedOption = selectedValue;
        this.onChange && this.onChange(
          this.input.onVarUpdate,
          { selectedObject: this.radioGroupItems.find((item:any) => item.value === selectedValue) }
        );
      }
    )
  }
})
